/**
 * Type-safe configuration parameter names
 * Use these enums to prevent typos when accessing config
 */

export enum ConfigKey {
  ENVIRONMENT = 'environment',
  API_URL = 'apiUrl',
  API_TIMEOUT = 'apiTimeout',
  ENABLE_DEBUG = 'enableDebug',
  APP_VERSION = 'appVersion',
}

export enum EnvVarKey {
  // Environment
  VITE_ENVIRONMENT = 'VITE_ENVIRONMENT',
  NODE_ENV = 'NODE_ENV',
  VITE_APP_ENV = 'VITE_APP_ENV',
  MODE = 'MODE',
  DEV = 'DEV',

  // Service Endpoints
  VITE_SERVICE_API_URL = 'VITE_SERVICE_API_URL',
  VITE_SERVICE_FRONTEND_URL = 'VITE_SERVICE_FRONTEND_URL',
  VITE_SERVICE_WEB_URL = 'VITE_SERVICE_WEB_URL',
  VITE_API_TIMEOUT = 'VITE_API_TIMEOUT',

  // Authentication
  VITE_AUTH_DOMAIN = 'VITE_AUTH_DOMAIN',
  VITE_AUTH_CLIENT_ID = 'VITE_AUTH_CLIENT_ID',

  // Analytics
  VITE_GA_ID = 'VITE_GA_ID',
  VITE_HOTJAR_ID = 'VITE_HOTJAR_ID',

  // Feature Flags
  VITE_DEBUG = 'VITE_DEBUG',

  // Build Info
  VITE_APP_VERSION = 'VITE_APP_VERSION',
}

export enum RouteConfigKey {
  SCREEN = 'screen',
  REQUIRES_AUTH = 'requiresAuth',
  PUBLIC_ONLY = 'publicOnly',
  ALLOW_DEMO_USER = 'allowDemoUser',
  ALLOW_REGULAR_USER = 'allowRegularUser',
}
